import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo-dark.svg'


const _hoisted_1 = { class: "w-full max-w-full p-8 bg-[url(@/assets/bg-menu.webp)] bg-cover text-white" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex flex-col gap-5" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-0.5 bg-light-green mx-auto" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-0.5 bg-light-green mx-auto" }, null, -1)
const _hoisted_7 = { class: "flex gap-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-24"
}, null, -1)
const _hoisted_9 = { class: "flex flex-col gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-0.5 bg-light-green mx-auto" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs leading-relaxed text-center" }, [
  /*#__PURE__*/_createTextVNode(" Property of 11x12 Solutions Inc."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" All rights reserved. ")
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'footer-sm',
  setup(__props) {

const footerItems = {
  services: [
    { title: "Family Space", link: "#family-space" },
    { title: "Commercial", link: "#commercial" },
    { title: "Putting Greens", link: "#putting-greens" },
    { title: "Happy Pets", link: "#happy-pets" },
    { title: "Landscape Lightings", link: "#lighting" },
  ],
  locations: ["Hamilton", "Burlington", "St. Catharines", "Niagra"],
  contact: [
    "info@perfectgreen.ca",
    "+1 (905) 674-5983",
    "",
  ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.services, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.title,
            href: item.link,
            class: "text-base font-medium text-center leading-[1]"
          }, _toDisplayString(item.title), 9, _hoisted_4))
        }), 128)),
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.locations, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "text-base font-medium text-center leading-[1]"
          }, _toDisplayString(item), 1))
        }), 128)),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerItems.contact, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "text-base leading-normal",
                key: item
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]),
        _hoisted_10,
        _hoisted_11
      ])
    ])
  ]))
}
}

})